__turbopack_context__.v({
  "container": "TestimonialsSection-module-scss-module__mDtEMa__container",
  "content": "TestimonialsSection-module-scss-module__mDtEMa__content",
  "ellipse": "TestimonialsSection-module-scss-module__mDtEMa__ellipse",
  "icon": "TestimonialsSection-module-scss-module__mDtEMa__icon",
  "nextButton": "TestimonialsSection-module-scss-module__mDtEMa__nextButton",
  "prevButton": "TestimonialsSection-module-scss-module__mDtEMa__prevButton",
  "quote": "TestimonialsSection-module-scss-module__mDtEMa__quote",
  "sliderWrapper": "TestimonialsSection-module-scss-module__mDtEMa__sliderWrapper",
  "swiper": "TestimonialsSection-module-scss-module__mDtEMa__swiper",
  "wrapper": "TestimonialsSection-module-scss-module__mDtEMa__wrapper",
});
